import PropTypes from "prop-types";
import {
  MATTER_TYPE_LIQUID as LIQUID,
  MATTER_TYPE_SOLID as SOLID,
  PER_100_LITERS,
  PER_HECTARE
} from "../Farms";

export const ELEMENTS_LIST = [
  "N",
  "K",
  "Mg",
  "Fe",
  "Mn",
  "Cu",
  "Cl",
  "P",
  "Ca",
  "S",
  "B",
  "Zn",
  "Mo",
  "Na"
];
export const ELEMENTS_LIST_SIDEBAR = [
  "N",
  "P",
  "K",
  "Ca",
  "Mg",
  "S",
  "Fe",
  "B",
  "Mn",
  "Zn",
  "Cu",
  "Mo",
  "Cl",
  "Na"
];

export const CHEMICAL_MATTERS = {
  LIQUID: "Liquid",
  SOLID: "Solid"
};

export const FERTILISER = "Fertiliser";

export const chemicalShape = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  trackInventory: PropTypes.bool,
  matter: PropTypes.oneOf(Object.keys(CHEMICAL_MATTERS)),
  type: {
    id: PropTypes.number,
    type: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([FERTILISER])])
  },
  price: PropTypes.number,
  batchRequired: PropTypes.bool,
  rates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      crop: {
        id: PropTypes.number,
        name: PropTypes.string,
        spacingType: PropTypes.string // TODO: Use Enum
      },
      purpose: PropTypes.string,
      // minRate: PropTypes.number,
      // maxRate: PropTypes.number,
      rateType: PropTypes.oneOf([PER_100_LITERS, PER_HECTARE]),
      withholdingPeriod: PropTypes.number,
      comment: PropTypes.string,
      reentry: PropTypes.number
    })
  ),
  notes: PropTypes.string,
  sds: PropTypes.string,
  sdsAttachment: null, // TODO: Attachment
  label: PropTypes.string,
  labelAttachment: null, // TODO: Attachment
  poisonSchedule: PropTypes.string,
  activeIngredients: PropTypes.arrayOf(PropTypes.string),
  resistanceGroup1: PropTypes.string,
  resistanceGroup2: PropTypes.string,
  elements: PropTypes.shape({
    [PropTypes.oneOf(ELEMENTS_LIST)]: PropTypes.number
  }),
  dangerousProduct: PropTypes.bool,
  organic: PropTypes.bool,
  registrationNumber: PropTypes.string,
  attachments: PropTypes.shape({
    subPath: PropTypes.string,
    id: PropTypes.string,
    presignedUrl: PropTypes.string,
    name: PropTypes.string
  }),
  chemicalUserPermitNumber: PropTypes.string,
  permitExpDate: PropTypes.string,
  archived: PropTypes.bool,
  unit: PropTypes.string
});
